module.exports = __webpack_public_path__ + "static/img/red-bag-modal-btn.1d5e17e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/withdraw/red-bag-modal-btn.png
// module id = VfzI
// module chunks = 216